<template>
  <div class="flex flex-col gap-14">
    <!-- Section 1: Mission créée -->
    <div class="flex flex-col gap-8">
      <!-- Heading + Divider -->
      <div class="flex flex-col gap-6">
        <h2 class="text-xl font-bold text-gray-100 leading-tight">
          {{ $t('publish_mission.step4.success_description') }}
        </h2>
        <div class="h-px bg-gray-700 w-full" />
      </div>

      <!-- Share link + social buttons -->
      <b-share-mission :mission="mission" />
    </div>

    <!-- Section 2: Trouver un expert -->
    <div class="flex flex-col gap-8">
      <h2 class="text-xl font-bold text-gray-100 leading-tight">
        {{ $t('publish_mission.step4.find_expert_prompt') }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
import BShareMission from '~/components/mission/BShareMission.vue';
import type { Mission } from '~/api/v2/missions/MissionRepository';

defineProps<{
  mission?: Mission | null;
}>();
</script>
